import React from "react";
import PropTypes from "prop-types";
import Script from 'react-load-script';
import { loadYoutubeClient } from '../../lib/youtube-auth';

class GoogleScript extends React.Component {
  handleScriptError() {
    alert('Failed to load Google API script - refresh the page');
  }

  render() {
    return (
      <Script
        url="https://apis.google.com/js/api.js"
        onError={this.handleScriptError.bind(this)}
        onLoad={() => loadYoutubeClient(this.props.handleYoutubeClientLoad, this.props.updateSignInStatus)}
      />
    );
  }
};

export default GoogleScript;



// WEBPACK FOOTER //
// ./src/components/GoogleScript/GoogleScript.js